import { ModelBase } from '../abstract/model-base.model';
import { ClientContact } from '../client/contact.model';
import { PartnerContact } from '../partner/contact.model';
import { ConversationItem } from './conversation-item.model';

export class Conversation extends ModelBase {

    static override CLASS_NAME: string = 'Conversation';

    private _entityType!: string;
    private _externalParticipants!: PartnerContact[];
    private _internalParticipants!: ClientContact[];
    private _items!: ConversationItem[];
    private _objectId!: number;
    private _private!: boolean;
    private _title!: string;

    public constructor(data?: any) {
        super(data);
        this._internalParticipants = this.internalParticipants || [];
        this._items = this.items || [];
    }

    public get entityType(): string {
        return this._entityType;
    }

    public set entityType(value: any) {
        this._setValue('_entityType', value, 'string');
    }

    public get externalParticipants(): PartnerContact[] {
        return this._externalParticipants;
    }

    public set externalParticipants(value: any) {
        this._setValue('_externalParticipants', value, 'PartnerContact');
    }

    public get internalParticipants(): ClientContact[] {
        return this._internalParticipants;
    }

    public set internalParticipants(value: any) {
        this._setValue('_internalParticipants', value, 'ClientContact');
    }

    public get items(): ConversationItem[] {
        return this._items;
    }

    public set items(value: any) {
        this._setValue('_items', value, 'ConversationItem');
    }

    public get objectId(): number {
        return this._objectId;
    }

    public set objectId(value: any) {
        this._setValue('_objectId', value, 'integer');
    }

    public get private(): boolean {
        return this._private;
    }

    public set private(value: any) {
        this._setValue('_private', value, 'boolean');
    }

    public get title(): string {
        return this._title;
    }

    public set title(value: any) {
        this._setValue('_title', value, 'string');
    }
}
